// // Common types:
export type ID = string;
export type Ref = string;
export type Timestamp = number;
export type TagGroupId = ID;

// // Datatypes:
// tslint:disable-next-line:no-any
export type Context = any;
// tslint:disable-next-line:no-any
export type Metadata = any;

export type VideoContentType = 'camera' | 'screen';

// // REST API:
interface CreateCall {
  readonly users: ReadonlyArray<ID>;
  readonly metadata?: Metadata;
}

interface CreateDirectEntity {
  readonly user: ID;
}

interface CreateDirectCall extends CreateDirectEntity {
  readonly timeout?: number;
  readonly metadata?: Metadata;
}

interface CreateDirectRoom extends CreateDirectEntity {
  readonly context?: Context;
}

interface CreateRoom {
  readonly name: string;
}

interface LeaveReason {
  readonly reason: string;
}

interface Invite {
  readonly user: ID;
}

interface PushRegistration {
  readonly pushId: ID;
}

export const createCall = (users: ReadonlyArray<ID>, metadata?: Metadata): CreateCall =>
  ({
    users,
    metadata
  });

export const createDirectCall = (user: ID, timeout?: number, metadata?: Metadata): CreateDirectCall =>
  ({
    user,
    timeout,
    metadata
  });

export const leaveReason = (reason: string): LeaveReason =>
  ({
    reason
  });

export const createRoom = (name: string): CreateRoom =>
  ({
    name
  });

export const createDirectRoom = (user: ID, context?: Context): CreateDirectRoom =>
  ({
    user,
    context
  });

export const invite = (user: ID): Invite =>
  ({
    user
  });

export const pushRegistration = (pushId: ID): PushRegistration =>
  ({
    pushId,
  });

export interface HistoryFilter {
  readonly filter: ReadonlyArray<string>;
  readonly customFilter: ReadonlyArray<string>;
}

export interface Paginated<T> {
  readonly items: ReadonlyArray<T>;
  readonly offset: number;
  readonly limit: number;
}

export interface TurnConfig {
  readonly urls: Array<string>;
  readonly username: string;
  readonly password: string;
}
